var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-banner",class:[_vm.gameName,{'loged':_vm.gameID}]})
}
var staticRenderFns = []

export { render, staticRenderFns }